import axios from '@axios'
import store from '@/store'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(item => ({
        value: item.id,
        label: item.format,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getFormats() {
      const response = await axios.get('v1/stream-formats-configurations/?q=&formatType=true')
      return response.data.data;
    },
    async getResolutions() {
      const response = await axios.get('v1/stream-resolutions?q=&resolutionsType=true')
      return response.data.data;
    },
  },
}
